import {HRDashboard} from "components/hr/main/HRDashboard";
import * as React from "react";
import {observer} from "mobx-react";
import {HRTab} from "components/hr/widgets/HRTab";
import {useState} from "react";
import {HREmailTool} from "components/hr/main/HREmailTool";
import './HRMain.pcss';
import {HREmailHistory} from "components/hr/main/HREmailHistory";
import {UIState} from "data/UIState";

export const HRMain = observer(()=>{

    const [tabDashboard, setTabDashboard] = useState(true);
    const [tabEmailTool, setTabEmailTool] = useState(false);
    const [tabEmailHistory, setTabEmailHistory] = useState(false
    );

    // Bail out if the dashboard data is not yet initialized
    if(!UIState.dashboardData.initialized) {
        return null;
    }

    function onClickTab(setter:(val:boolean)=>void) {
        setTabDashboard(false);
        setTabEmailTool(false);
        setTabEmailHistory(false);
        setter(true);
    }

    return (
        <div className={"hr-main"}>

            <div className={"hr-tab-bar"}>
                <HRTab className={"hr-main"} selected={tabDashboard} onClick={()=>{onClickTab(setTabDashboard);}}>Reports</HRTab>
                <HRTab className={"hr-main"} selected={tabEmailTool} onClick={()=>{onClickTab(setTabEmailTool);}}>Send Email</HRTab>
                <HRTab className={"hr-main"} selected={tabEmailHistory} onClick={()=>{onClickTab(setTabEmailHistory);}}>Email History</HRTab>
            </div>

            {tabDashboard && <HRDashboard /> }
            {tabEmailTool && <HREmailTool /> }
            {tabEmailHistory && <HREmailHistory /> }

        </div>
    )

});
